import React from "react"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import FormControl from "@material-ui/core/FormControl"

import { FormHelperText, Input } from "@material-ui/core"

const OneAsOne = ({ handleChange, classes, name, cpf, email }) => {
    return (
        <div className={classes.bigContainer}>
            <Paper className={classes.paper}>
                <Typography variant="h5" component="h5">
                    Inscrição como Participante
        </Typography>
                <FormControl
                    variant="outlined"
                    className={classes.formControl}>

                    <Input
                        placeholder="Nome"
                        id="name"
                        name="name"
                        aria-describedby="name-helper"
                        required
                        onChange={handleChange}
                        value={name}
                    />
                    <FormHelperText id="name-helper">Nome Completo do Participante</FormHelperText>

                    <Input
                        placeholder="CPF"
                        id="cpf"
                        name="cpf"
                        aria-describedby="cpf-helper"
                        required
                        onChange={handleChange}
                        value={cpf}
                    />
                    <FormHelperText id="cpf-helper">CPF do Participante (sem pontos ou hífen)</FormHelperText>

                    <Input
                        placeholder="E-mail"
                        type="email"
                        id="email"
                        name="email"
                        aria-describedby="email-helper"
                        required
                        onChange={handleChange}
                        value={email}
                    />
                    <FormHelperText id="email-helper">E-mail do Participante</FormHelperText>
                </FormControl>
            </Paper>
        </div>
    );
}

export default OneAsOne;